// Demo presets for Kindergarten Communication of Learning: Initial Observations.

export const PRESETS = [
  {
    label: 'Example: Avery Park (Year 1)',
    data: {
      date: '2024-11-15',
      studentName: 'Avery Park',
      oen: '123456789',
      year: 'Year 1',
      daysAbsent: '2',
      totalDaysAbsent: '2',
      timesLate: '1',
      totalTimesLate: '1',
      frenchProgram: '',
      teacher: 'Ms. Patricia Rodriguez',
      earlyChildhoodEducator: 'Ms. Linda Chen',
      principal: 'Mr. David Thompson',
      telephone: '(416) 555-0123',
      board: 'Toronto District School Board',
      school: 'Sunrise Public School',
      schoolAddress: '123 Maple Street\nToronto, ON M5V 2T6',
      boardAddress: '5050 Yonge Street\nToronto, ON M2N 5N8',
      esl: '',
      iep: '',
      keyLearningComments:
        'Avery has settled into kindergarten with curiosity and warmth. ' +
        'During block-centre play, Avery designs stable structures and explains the choices to peers, demonstrating early problem solving. ' +
        'At circle time, Avery is listening attentively and beginning to take turns. ' +
        'Next steps will focus on extending oral storytelling during sharing time and on developing fine motor control through cutting and tracing.',
      boardInformation: '',
      eceNames: 'Ms. Linda Chen',
      _completedFields: [],
    },
  },
  {
    label: 'Example: Jaylen Lee (Year 2)',
    data: {
      date: '2024-11-18',
      studentName: 'Jaylen Lee',
      oen: '987654321',
      year: 'Year 2',
      daysAbsent: '0',
      totalDaysAbsent: '0',
      timesLate: '0',
      totalTimesLate: '0',
      frenchProgram: 'Core',
      teacher: 'Mr. Samuel Patel',
      earlyChildhoodEducator: 'Ms. Aisha Nguyen',
      principal: 'Ms. Elena Rossi',
      telephone: '(905) 555-0456',
      board: 'Peel District School Board',
      school: 'Maplewood Elementary',
      schoolAddress: '88 Cedar Ave\nMississauga, ON L5B 1Y3',
      boardAddress: '5650 Hurontario Street\nMississauga, ON L5R 1C6',
      esl: '',
      iep: 'true',
      keyLearningComments:
        'Jaylen returns to kindergarten this year with growing confidence and strong peer relationships. ' +
        'During emergent literacy activities, Jaylen recognizes and names many letters and is beginning to write recognizable words. ' +
        'In mathematics behaviours, Jaylen is counting reliably to twenty and sorting objects by attribute. ' +
        'Per the IEP, next steps include extending writing stamina and continuing to use visual supports during transitions.',
      boardInformation: '',
      eceNames: 'Ms. Aisha Nguyen',
      _completedFields: [],
    },
  },
]
